module.exports = __webpack_public_path__ + "static/media/panenka.ff889fb0.png";